import type { ReactNode } from 'react'

import { env } from '@/lib/env'

/**
 * The frame for the three screens that stand between a person and a session: sign-in, the TOTP
 * challenge, and a forced password change. Deliberately plain — nothing here is clickable except
 * the form, and no navigation exists to wander into before the session does.
 */
export function AuthLayout({
  title,
  description,
  children,
}: {
  title: string
  description?: string
  children: ReactNode
}) {
  return (
    <div className="inset-safe-x inset-safe-top inset-safe-bottom flex min-h-full items-center justify-center bg-canvas px-4 py-10">
      <div className="w-full max-w-sm space-y-5">
        <div className="flex items-center gap-2.5">
          <span
            className="flex size-9 items-center justify-center rounded-md bg-brand-fill text-on-brand-fill"
            aria-hidden
          >
            <svg viewBox="0 0 32 32" className="size-5" fill="none" stroke="currentColor" strokeWidth={3}>
              <path d="M8 22V10.5l8 6 8-6V22" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <div>
            <p className="text-sm font-semibold text-heading">Microcredit</p>
            <p className="text-xs text-muted">Back office</p>
          </div>
        </div>

        <div className="rounded-card border border-border-subtle bg-surface p-5 shadow-xs">
          <div className="mb-4 space-y-1">
            <h1 className="text-base font-semibold text-heading">{title}</h1>
            {description ? <p className="text-xs text-body">{description}</p> : null}
          </div>
          {children}
        </div>

        <p className="text-center text-2xs text-muted">
          Authorised users only. Every sign-in attempt is recorded.
          {env.environmentLabel && !env.isProduction ? ` · ${env.environmentLabel}` : ''}
        </p>
      </div>
    </div>
  )
}
